import App from './App.svelte';
import "toastify-js/src/toastify.css";

/** FAB Component */
const app = new App({
	target: document.querySelector("#fab-dom")
});

export default app;